import { STATUS_ENUM } from './reducers.types';
import { Region } from './region.types';

export interface RegionPickerState {
	initialized: STATUS_ENUM;
	regions: Region[];
}
